import flow from 'lodash/flow';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import type { IOdds } from '@/interface/IOdds';
import { isFastMarket, isFiveMinFastMarket, isOneMinFastMarket, marketTypeDisplayOrder } from '@/libraries/oddsDisplay';

const oddsGroupingFlow = (results: IOdds[]) => {
    const sortSportsListPipe = flow(
        (results: IOdds[]) => orderBy(results, [odds => odds.sortOrder], ['desc']),
        (results: IOdds[]) => groupBy(results, odds => `${odds.marketGroup.id}-${odds.marketType}`),
    );
    return sortSportsListPipe(results);
};

export const moreMarketOddsGrouping = (oddsList: IOdds[]) => {
    const filterOdds = oddsList.filter(odds => !isFastMarket(odds.marketGroup.id));
    const flowResult = oddsGroupingFlow(filterOdds);
    return Object.values(flowResult);
};

export function groupMoreMarketOddsForDisplay(moreMarketOddsList: IOdds[]) {
    const oneMinFastMarket = moreMarketOddsList.filter(odds => isOneMinFastMarket(odds.marketGroup.id));
    const fiveMinFastMarket = moreMarketOddsList.filter(odds => isFiveMinFastMarket(odds.marketGroup.id));
    const otherMarkets = moreMarketOddsGrouping(moreMarketOddsList);
    const allGrouping = [oneMinFastMarket, fiveMinFastMarket, ...otherMarkets].filter(x => !!x && x.length > 0);
    return orderBy(allGrouping, [
        oddsList => oddsList[0].marketGroup.displayPriority,
        oddsList => marketTypeDisplayOrder.indexOf(oddsList[0].marketType),
    ]);
}
